'use strict';
const merge = require('webpack-merge');
const base = require('./base');

module.exports = merge(base, {
  sendLabel: '发送',
  learnMore: '更多资料',
  welcome: '您好，NKN团队很高兴为您服务！请问有什么需要？',
  dataRide: {
    banner1: {
      title: '数据旅行',
      text: '<strong>dataRide - 数据之旅（简称数旅）</strong> 是一种高效、可靠、安全和低成本的去中心化数据传输和连接服务平台（PaaS），适用于人与人、机器与人以及机器与机器之间的消息投递和文件传输。'
    },
    banner2: {
      title: '数据旅行',
      subTitle: '使用场景',
      text: `<ul>
<li style="list-style: inside">即时通讯</li><li style="list-style: inside">外设直连</li><li style="list-style: inside">点对点直连</li><li style="list-style: inside">在线客服</li><li style="list-style: inside">远程控制</li><li style="list-style: inside">监控摄像机控制</li><li style="list-style: inside">警报、更新通知</li>
</ul>`,
      icon1: '即时通讯',
      icon2: '外设直连',
      icon3: '点对点直连',
      icon4: '在线客服',
      icon5: '远程控制',
      icon6: '安全监控',
    },
    banner3: {
      title: '开发者优势',
      title1: '简单并且轻量级的SDK',
      text1: `<ul>
<li style="list-style: inside">只有数行代码</li><li style="list-style: inside">同时支持手机和网页端</li><li style="list-style: inside">兼容多种开发语言: Javascript, Go, Android, iOS</li>
</ul>`,
      title2: '免费安装且低成本节点搭建',
      text2: `<ul>
<li style="list-style: inside">只需简单几步即可搭建自己的节点</li><li style="list-style: inside">充足的免费试用期</li><li style="list-style: inside">搭建规模越大、成本越低</li>
</ul>`,
      title3: '免费且开源',
      text3: `<ul>
<li style="list-style: inside">无专用平台锁定</li><li style="list-style: inside">代码中无后门程序</li><li style="list-style: inside">庞大的社群共同维护bug以及新功能开发</li>
</ul>`,
    },
    banner4: {
      title: '开发者优势',
      title1: '可靠',
      text1: `<ul>
<li style="list-style: inside">随时随地远程存取档案</li><li style="list-style: inside">不存在中心化服务器停机导致业务停摆</li>
</ul>`,
      title2: '私密且安全',
      text2: `<ul>
<li style="list-style: inside">用户信息在每个终端以及节点上都是加密的</li><li style="list-style: inside">用户所有信息在任何节点上都不会被储存</li>
</ul>`,
      title3: '全球信息高速传输',
      text3: `<ul>
<li style="list-style: inside">已被实验证明的高速全球传输</li><li style="list-style: inside">聚合多条高速传输路径</li>
</ul>`,
    },
    banner5: {
      title: '使用数据旅行架构的App',
      title1: 'D-Chat',
      url1: 'https://forum.nkn.org/t/d-chat/1862',
      title2: 'nMobile',
      url2: 'https://nmobile.nkn.org/downloads',
      title3: 'nShell',
      url3: 'https://forum.nkn.org/t/nkn-shell-nsh-ssh/1741',
      title4: 'MaoPan App',
      url4: '',
    },
    banner6: {
      title: '工程师们 — 立刻开始你的数据旅行!',
      text: '“数据旅行”现在可以在NKN的主网上下载，并且在全球已有20,000个传输节点.；点击进入”数据旅行“的搭建学习网页，然后免费开始搭建”数据旅行“的节点吧！'
    },
  },
  dataRideSupport: {
    banner1: {
      title: '客服系统',
      subTitle: '由 NKN 提供底层技术支持',
      text: '客服系统为网站和应用程序提供了一个开放且易于使用的嵌入式聊天解决方案，可帮助您实时与客户联系。'
    },
    banner2: {
      iconText1: 'NKN Wallet',
      iconText2: 'NKN Multi-client',
      title: 'Open SDK',
      text: 'NKN提供常用语言（例如<a class="link" href="https://github.com/nknorg/nkn-multiclient-js" target="_blank">Javascript</a>, <a class="link" href="https://github.com/nknorg/nkn-sdk-go" target="_blank">go</a> 和 <a class="link" href="https://github.com/nknorg/nkn-sdk-android" target="_blank">android</a>）的开源SDK，从而可以轻松地将NKN的客服系统解决方案嵌入到您的项目中。'
    },
    banner3: {
      title: 'D-Chat 客服系统',
      subTitle: '客服端',
      text: '使用Chrome / Brave浏览器上的 <a class="link" href="https://chrome.google.com/webstore/detail/d-chat/glnmkakdjcognfgonjfcklpmjiobijii" target="_blank">D-Chat插件</a> 或 Android 上的nMobile来管理您的客户服务团队访问并实时响应消息。'
    },
    banner4: {
      title: 'Vue 客服系统组件',
      text: '需要示例代码来帮助您建立聊天气泡? 查看开源的 <a class="link" href="https://github.com/iheron/vue-nkn-chat" target="_blank">vue 客服系统组件</a>.'
    },
    step1: {
      title: '只需3个简单的步骤即可立即集成客服系统',
      text: `<p>导入 nkn-wallet SDK并以TOPIC.PublicKey格式订阅您的私有频道。</p>
<br>
<p style="word-break: break-all; font-size: 9px;">ex. JasonsInsurance.25ac590eaca614a0ba4c4387d8514a0b54e948d120c6ff49564e7830c9dec929</p>`
    },
    step2: {
      text: `<p>导入 nkn-multiclient SDK.</p>
<br>
<p>multiclient 将获得你在步骤1中订阅的客服人员的 NKN 地址。</p>
`
    },
    step3: {
      text: `<p>添加发送和接收客户消息的功能</p>
<br>
<p>现在您的客服系统可以使用了!</p>
`
    }
  },
  nCDN: {
    banner1: {
      title: 'nCDN - 基于NKN的新型内容投递网络',
      subTitle: '基于NKN的新型内容投递网络',
      text: 'nCDN是一种为网站、视频和丰富媒体内容提供加速性能的众包服务。'
    },
    banner2: {
      title: '我们的优势',
      text: '我们的解决方案将传统的CDN和分布式的P2P CDN的最佳元素结合在一起，形成了提供可靠、低成本的大规模的内容交付网络。'
    },
    banner3: {
      title: '全球最大的共享网络',
      text: 'nCDN是基于NKN经过验证的去中心化网络架构，该网络架构拥有覆盖全球40多个国家和地区的20,000多个全共识节点。'
    },
    banner4: {
      title: '简易的自助服务门户',
      text: '通过我们的自助服务门户，可以便捷的注册和试用nCDN并提高您的网站或应用程序的性能。'
    },
    banner5: {
      title: '最佳的选择',
      text: '我们的低成本共享网络模式，加上NKN的高可用性的全球网络，使nCDN成为满足您的内容投递需求的最佳选择。',
      icon1: '低成本',
      icon2: '稳定可靠',
      icon3: '全球规模',
    },
    banner6: {
      title: '网站管理员：立刻体验nCDN测试版！',
      text: 'nCDN目前正处于针对预选的大企业客户和中小企业客户进行Beta测试阶段。 请登陆ncdn.io申请免费试用，并查看nCDN如何帮助您在全球范围内将大规模应用扩展到您的网站。',
      icon1: '网站加速',
      icon2: '文件缓存',
      icon3: '下载加速',
    },
  },
  alert: {
    title: '点击此处进行NKN NEP-5 代币到NKN ERC20 的代币切换',
    dlTip: '截止日期:北京时间2019年3月29日早8点整',
    btn: '知道了'
  },
  chat: {
    service: '客服系统'
  },
  header: {
    langSel: '语言',
    nav: {
      tab1: '开发者',
      tab2: '节点共建者',
      tab3: '合作伙伴',
      tab4: '新闻',
      tab5: '关于',
      tab6: '解决方案',
      tab7: 'nCDN',
      tab8: '数据旅行',
      tab9: '团队',
      tab10: '产品路线图',
      tab11: 'nMobile',
      tab12: '博客',
      tab13: 'nMobile-pro',
    }
  },
  footer: {
    nav: {
      title: '导航',
      tab1: '开发者',
      tab2: '节点共建者',
      tab3: '合作伙伴',
      tab4: '新闻',
      tab5: '关于'
    },
    community: {
      title: '社区',
      tab1: 'Telegram',
      tab2: 'Twitter',
      tab3: 'Reddit',
      tab4: 'Discord',
      tab5: 'Medium',
      tab6: 'YouTube',
      tab7: '论坛',
      tab8: '微博'
    },
    resource: {
      title: '资源',
      tab1: 'Github',
      tab2: '项目概况',
      tab3: '白皮书',
      tab4: '下载Logo',
      tab5: '开发者文档',
      tab6: '核心技术',
    },
    subscribe: {
      title: '更多信息请订阅邮件',
      inputph: '您的邮件地址',
      btn: '订阅',
      success: '您已经成功订阅了NKN新闻！',
      notice: '不要错过NKN的最新活动信息！'
    },
    copyright: ' Copyright © 2017-2020 NKN | All rights reserved'
  },
  network: {
    title: {
      rank: '排名',
      country: '国家',
      nodes: '节点数'
    },
    totalCount: '当前NKN总节点数：',
    updatetime: '更新时间：{updatetime}'
  },
  home: {
    press: '媒体',
    header: {
      title: 'NKN：新一代互联网的网络基础设施',
      desc:
        'NKN是区块链技术驱动的一种开放、去中心化的新型网络。NKN倡导用户共享网络资源，鼓励大家构建人人为我，我为人人的共建共享对等网络，在让共建者因协助数据传输而获得经济回报的同时为开发者提供一个开放，便捷，高效和安全的网络平台，让所有人都能体验更好的网络应用和服务。',
      btn1: '项目介绍',
      btn2: '体验主网',
      news: '新闻: nCDN简介',
    },
    swiper: {
      title1: 'NKN正式上线Bittrex国际交易所',
      title2: 'NKN主网 V0.9 Beluga 正式发布',
      title3: 'NKN代币平台切换：',
      title3sub: '从NEP-5转到ERC-20：',
      title4: 'NKN正式上线UPbit交易所',
      title5: '',
      content1sub1: 'NKN/BTC交易对链接：',
      content1sub2:
        '<a href="https://international.bittrex.com/Market/Index?MarketName=BTC-NKN" target="_blank">https://international.bittrex.com/Market/Index?MarketName=BTC-NKN</a>',
      content2:
        '2019年3月31日 NKN 正式发布 Mainnet V0.9 Beluga。 除了高度可扩展网络和共识，此版本侧重于区块链帐本和安全性增强，是我们主网终上线之前的最后一个主要版本。',
      content3sub1: '一个NEP-5 NKN币（NKN）兑换为一个ERC-20 NKN币。',
      content3sub2: 'gate.io交易所将于2019年1月开始支持为其客户自动进行转换。',
      content3sub3:
        '如果您将代币存放在私人钱包中，请使用NKN官网上的代币交换工具手动进行转换。',
      content4sub1: 'NKN/BTC交易对链接：',
      content4sub2:
        '<a href="https://sg.upbit.com/exchange?code=CRIX.UPBIT.BTC-NKN" target="_blank">https://sg.upbit.com/exchange?code=CRIX.UPBIT.BTC-NKN</a>',
      content5:
        '我们荣幸地宣布Web3Infra联盟正式成立，这将是一个在分布式和共享经济中蓬勃发展且完全开放的Web 3.0开发平台。 NKN很荣幸和Bluzelle，NOIA Network和Portal Network一起，成为四个创始成员之一。'
    },
    walletAndExplorer: {
      title: '区块链钱包和浏览器',
      title1: '官方 NKN 钱包',
      subTitle1: '官方 NKN 主网钱包',
      title2: '官方 NKN 浏览器',
      subTitle2: '官方 NKN 主网浏览器',
      title3: 'NKNx 开发的 NKN 主网浏览器',
      subTitle3: '节点和钱包管理器',
      title4: 'nStatus',
      subTitle4: '一个简单的 NKN 节点状态工具',
      title5: 'NKNx开发的桌面钱包',
      subTitle5: '适用于Windows和Mac操作系统的桌面钱包',
    },
    wordmap: {
      title: 'NKN全网全球节点分布',
      nodeDistribution:
        '<span class="full-node-title">全节点：</span><span class="full-node-count">{total}个</span>',
      nodeByRegions:
        '运行NKN节点的国家和地区: {count}个 (<a href="/zh/miner/" target="_self">如何成为NKN节点</a>)',
      details: 'NKN的全节点数量已经超过比特币网络，正在建造一个全球最大的区块链网络传输系统。'
    },
    whynkn: {
      title: 'NKN解决的问题',
      subtitle1: '传统互联网Client-Server模式的固有缺陷',
      subtitle2: '网络资源未被充分利用',
      subtitle3: '区块链系统的中心化降低其可信度',
      subContent1: `现有的大多数网络应用都需要通过一个集中式的服务器进行连接和通信，这种模式很容易产生单点故障或遭到人为破坏和窥探用户隐私。`,
      subContent2: `现在的网络是为高峰流量而设计的，但大多数时候这些个体的网络资源并未得到充分的利用或处于闲置状态，时刻都有带宽资源被浪费掉。`,
      subContent3: `有很多区块链通过牺牲系统的去中心化性来提升性能或者可控度。这实际上极大的削弱了区块链系统的可信任度和安全性。`
    },
    nknAdvantage: {
      title: 'NKN的优势',
      subtitle1: '百万节点互联共识',
      subtitle2: '网络聚合加速',
      subtitle3: '低延迟率',
      subtitle4: '零服务器',
      subtitle5: '唯一的全球标识',
      subtitle6: '更安全和注重隐私',
      subContent1:
        '创新的MOCA共识算法，高度可扩展并支持任意数量的共识节点。NKN主网有近25000个共识全节点，超越了比特币和以太坊规模。',
      subContent2:
        '节点和客户端数据传输可以利用多点路径的聚合速度。在网络中添加更多的NKN节点可以大规模提高整个网络的吞吐量。',
      subContent3:
        '支持各种类型的应用程序，包括实时3D游戏，AR / VR和物联网。支持边缘计算和路径优化。 NKN节点间数据支持链下传输，不受共识速度的限制。',
      subContent4:
        '实现完全的对等和真正的去中心化，无需开发和运行中心化服务器。显著降低系统架构的复杂性和成本，避免因单点故障所造成的服务瘫痪和成为黑客攻击的中心化目标。',
      subContent5:
        '唯一标识的NKN地址可以让网络服务在世界上任意时间地方与客户端建立连接; 帮助人们发现和搜索应用程序和服务。',
      subContent6:
        '支持端到端和逐跳加密，无需额外公钥基础设施或第三方认证机构。'
    },
    nknProduct: {
      title: 'NKN应用场景示例',
      applications: {
        title: 'dApps',
        tab1: '太空猫，无需服务器多用户实时的3D动作游戏',
        tab2: 'NKN 聊天工具，分布式即时通讯工具',
        tab3: '智能家居物联网，基于NKN的海量IOT设备端到端安全通信解决方案',
        tab4: 'D-chat，无需服务器基于NKN Pub/Sub的实时聊天',
        tab5: 'Tuna, 软件服务的开放式网络市场',
        tab6: 'NKN Shell (nsh), 比SSH更安全更方便的远程终端',
        tab7: 'd-FTP, 基于NKN的高速文件传输应用',
      },
      wallet: {
        title: '钱包、系统管理和展示平台',
        tab1: 'NKN官方钱包',
        tab2: '社区新型钱包NKNWallet.io'
      },
      dashboard: {
        title: '系统管理和展示平台',
        tab1: '测试网浏览器',
        tab2: '主网浏览器',
        tab3: '社区开发系统管理工具',
        tab4: '节点和钱包管理器'
      },
      flagshipProducts: {
        title: '旗舰产品',
        tab1: 'nCDN - 新型CDN',
        tab2: 'PubSub - 分布式消息服务 Pub/Sub'
      }
    },
    platformServices: {
      platformServicesTitle: 'NKN平台服务（PaaS）',
      txtTitle: 'Communication as a Service (CaaS) Solution',
      txtDesc: 'open, dependable, fast, scalable platform services for enterprises and developers',
      nPubSub: {
        title: '数据之旅',
        desc: `<strong>dataRide - 数据之旅（简称数旅）</strong> 是一种高效、可靠、安全和低成本的去中心化数据传输和连接服务平台（PaaS），适用于人与人、机器与人以及机器与机器之间的消息投递和文件传输。
<ul>
<li style="list-style: inside"><a href="https://dataride.nkn.org/chat/" target="_blank"><strong>即时通讯</strong></a></li><li style="list-style: inside"><a href="https://dataride.nkn.org/iot/" target="_blank"><strong>IoT 设备</strong></a></li><li style="list-style: inside"><a href="https://dataride.nkn.org/filetransfer/" target="_blank"><strong>文件传输</strong></a></li><li style="list-style: inside"><a href="https://dataride.nkn.org/support/" target="_blank"><strong>客服系统</strong></a></li><li style="list-style: inside"><a href="https://dataride.nkn.org/remotecontrol/" target="_blank"><strong>远程控制</strong></a></li><li style="list-style: inside"><a href="https://dataride.nkn.org/camera/" target="_blank"><strong>监控摄像机控制</strong></a></li><li style="list-style: inside"><strong>警报、更新通知</strong></li>
</ul>`
      },
      nCDN: {
        title: 'nCDN - 基于NKN的新型内容投递网络',
        subtitle: '基于NKN的新型内容投递网络',
        desc: `nCDN是一种为网站、视频和丰富媒体内容提供加速性能的众包服务。`
      }
    },
    communityDApp: {
      title: '基于NKN的去中心化应用',
      nMobile: {
        title: 'nMobile',
        text: `一款结合NKN钱包、D-Chat、NKN新闻、挖矿节点监控、IOT通信与控制的移动应用`,
        url: 'https://nmobile.nkn.org/downloads/nMobile.apk',
        betaUrl: 'https://nmobile.nkn.org/downloads/nMobile-beta.apk'
      },
      nMobilePro: {
        title: 'nMobile Pro',
        text: `一款结合NKN钱包、D-Chat、NKN新闻、挖矿节点监控、IOT通信与控制的移动应用`,
        url: 'https://nmobile.nkn.org/downloads/nMobile-pro.apk',
      },
      dChat: {
        title: 'D-chat',
        text: `一款无服务器的聊天应用，适用公开或私有群聊、安全和私密的一对一私聊和与设备之间的通信。`,
        url: 'https://forum.nkn.org/t/d-chat/1862'
      },
      nFtp: {
        title: 'nFTP',
        text: `在没有任何服务器的任意客户端之间直接、安全和高速的文件传输服务。`,
        url: 'https://forum.nkn.org/t/nkn-d-ftp-nkn/1738'
      },
      nShell: {
        title: 'nShell',
        text: `一种比SSH更安全，更方便的新型远程终端。`,
        url: 'https://forum.nkn.org/t/nkn-shell-nsh-ssh/1741'
      }
    }
  },
  developer: {
    title: '开发者',
    clientIntro: {
      title: 'NKN介绍视频',
      vtitle1: 'NKN项目简介',
      vtitle2: 'NKN客户端SDK简介'
    },
    dapp: {
      title: '应用实例',
      title2: '平台服务',
      subtitle1: '太空猫游戏',
      subtitle2: 'NKN聊天工具',
      subtitle3: 'nknx.org 网站',
      subtitle4: '开发者奖励计划',

      subtitle5: '智能家居物联网',
      subtitle6: 'D-chat',
      subtitle7: '新型CDN',
      subtitle8: '智能家居物联网',
      subtitle9: 'dataRide',
      subtitle10: 'TUNA',
      subtitle11: 'NanoPay',
      subtitle12: 'Wallet',
      subtitle13: 'NKN浏览器',
      subtitle14: '节点和钱包管理器',
      subtitle15: 'NKN Shell',
      subtitle16: 'd-FTP',
      subtitle17: 'NKN客户端数据传输并发方案',
      subtitle18: '数据旅行',

      subContent1: '无需服务器多用户实时的3D动作游戏。',
      subContent2: '使用NKN客户端SDK构建的分布式即时通讯程序。',
      subContent3: '社区开发的包含市场走势，系统管理和展示的一体化界面，其中还包括区块链资源管理器、钱包、矿工节点管理器和资产跟踪器。支持6种语言。',
      subContent4: '对于将已有知名开源IM应用程序移植到NKN，且拥有每日活跃用户超过500的最佳应用，我们承诺给与不低于100,000 NKN的奖励。',
      subContent8: '基于NKN的海量IOT设备端到端安全通信解决方案。',
      subContent9: '去中心的实时信息订阅分发系统。',
      subContent10: '软件服务的开放式网络市场。',
      subContent11: '高效率的微支付通道',
      subContent12: '官方主网钱包。',
      subContent13: '区块链浏览器和节点状态检测。',
      subContent14: '矿工节点和钱包统一监控门户工具。',
      subContent15: '比SSH更安全更方便的远程终端.',
      subContent16: '基于NKN的高速文件传输应用.',
      subContent17: '提升可靠性和降低延迟.',
      subContent18: '去中心化数据传输和连接服务平台（PaaS）',

      subContent1Link1: '演示链接',
      subContent1Link2: '下载链接',
      subContent2Link1: '点击尝试',
      subContent3Link1: '链接',
      subContent3Link2: 'GitHub',
      subContent3Link3: '项目管理',

      subContent5: '基于NKN的海量IOT设备端到端安全通信解决方案。',
      subContent5Link1: '更多信息',
      subContent6: '无需服务器基于NKN Pub/Sub的实时聊天。',
      subContent6Link1: '点击尝试',
      subContent6Link2: 'Gitlab',
      subContent7: '用分布式的边缘节点搭建的内容分发系统。',
    },
    coreTech: {
      title: '核心技术',
      subtitle1: '去中心化的数据传输网络（DDTN）',
      subContent1:
        'NKN基于Chord DHT 维护动态拓扑和路由，可为数百万甚至数十亿的节点和客户提供随时加入和离开的服务。 唯一的NKN地址用于识别节点，在TCP/IP之上提供网络覆盖层。',
      subtitle2: '中继证明 (PoR)',
      subContent2:
        'PoR用有效数据传输量去衡量路由中继节点的工作量。 构造签名链来保证其可验证性，不可伪造性及不可篡改性。',
      subtitle3: '高度可扩展的共识机制（MOCA）',
      subContent3:
        'NKN借鉴元胞自动机创新实现了一种高度可扩展的共识机制（MOCA），可支持下一代互联网级别节点数目的区块链系统快速共识。',
      subtitle4: '网络资源共享激励',
      subContent4:
        'NKN的经济模型奖励为其他用户提供数据中转或转发的参与者。充分调动参与者的积极性，能够有效地激励更多参与者为他人提供网络服务以获取经济回报。共建共享新型网络基础设施。'
    },
    bounty: {
      title: '开发者奖励计划',
      subtitle1: '$ $ $',
      subContent1:
        '对于将已有知名开源IM应用程序移植到NKN，且拥有每日活跃用户超过500的最佳应用，我们承诺给与不低于100,000 NKN的奖励。',
      subContent1Link1: '链接'
    },
    resources: {
      title: '开发者资源',
      subtitle1: 'Github代码库',
      subtitle2: '文档和帮助',
      doc: '开发者文档',
      subtitle3: '开发者工具',
      subtitle4: '社区的客户端SDK'
    }
  },
  miner: {
    title: '网络矿工指南',
    miningIntro: {
      title: 'NKN挖矿指南',
      vtitle: '在这个1分钟的视频中了解一下NKN挖矿'
    },
    started: {
      title: '现在开始吧',
      subtitle1: '挖矿英文介绍',
      subtitle2: '挖矿中文介绍',
      subtitle3: '其他语言的挖矿介绍',
      sub1li1: '带有编译链接的综合挖矿指南',
      sub1li2: '使用Digital Ocean云服务器在5分钟内开通NKN矿工账号',
      sub1li3: '如何在Windows 10上开通NKN 挖矿功能并自动运行服务',
      sub1li4: '使用Raspberry pi制作自己的NKM（新型矿工）',
      sub1li5: '设置Raspberry Pi作为NKN矿机的脚本程序',
      sub2li1: 'NKN挖矿中文指南',
      sub2li2: 'NKN挖矿日语指南 (Digital Ocean cloud)',
      sub2li3: 'NKN挖矿日语指南 (Raspberry Pie)'
    },
    software: {
      title: '获取NKN挖矿软件',
      subtitle1:
        '如果您使用自己的笔记本电脑或台式电脑，可以下载图形化一键挖矿程序',
      subtitle2: '如果您使用云服务器或嵌入式设备，可以下载并安装命令行挖矿程序',
      githubBtn: '挖矿程序下载',
      tutorial: '教程',
      pcMining: 'PC 挖矿',
      n1Mining: 'N1 挖矿',
      raspberryPiMining: '树莓派挖矿',
      oneClickMining: '云平台一键挖矿'
    },
    tools: {
      title: '传输挖矿工具和资源',
      subtitle1: '主网浏览器',
      subtitle2: '社区建立的节点和钱包管理器',
      subtitle3: '社区建立的节点管理和展示面板'
    }
  },
  partner: {
    title: '合作伙伴',
    topology: {
      nodeBC: '区块链项目',
      nodeCloud: '云计算平台',
      nodeTelco: 'Enterprise',
      nodeApp: '应用软件开发商'
    },
    more: {
      title: '生态吸引力',
      subtitle1: '网络漫游',
      subContent1: '无论何时何地， 任何设备都可以轻松接入NKN网络。',
      subtitle2: '共享网络资源',
      subContent2:
        '参与者通过将闲置的网络资源分享给他人，从NKN系统中获得奖励。',
      subtitle3: '共建网络设施',
      subContent3:
        'NKN鼓励个体及企业部署设备为其它节点提供服务，在增强网络连通性和吞吐量的同时自动结算来获益。'
    },
    list: {
      title: 'NKN 合作伙伴',
      research: {
        title: '研发合作伙伴',
        crypticTitle: 'Cryptic 实验室',
        crypticText: `NKN正在与Cryptic实验室合作，推动NKN区块链技术背后的密码学研究。此外，Whitfield Diffie教授担任NKN团队的技术顾问。`
      },
      telco: {
        title: 'Enterprise',
        tipTitle: 'TIP',
        tipText: `NKN加入了电信基础设施项目（TIP），将NKN的数字化连接协议和经济激励机制引入Edge Compute，Open Cellular和TIP社区实验室等项目，以帮助推动创新并推动新电信解决方案的进步。`,
        onfTitle: 'ONF',
        onfText: `NKN已加入开放式网络基金会（ONF），参与ONOS和Stratum等项目，以增强软件定义网络（SDN），并为部署开源基础架构解决方案提供数字化的经济激励。`,
        dpTitle: 'Datapace',
        dpText: `NKN与Datapace合作，在NKN的全球点对点网络上对Datapace的分布式数据市场和传感器生态系统提供网络支持。`
      },
      cloud: {
        title: '云计算平台',
        gcTitle: 'Google Cloud',
        gcText: `
        Google 云被普遍认为是提供安全，开放，智能和变革性企业云平台的全球领导者。我们的技术建立在Google的专用网络之上，是安全，网络架构，协作，人工智能和开源软件近20年创新的产物。我们在Google Cloud Platform和G Suite中提供了一套简单设计的工具和无与伦比的技术，可以将人员，见解和想法结合在一起。超过150个国家/地区的客户信任Google云，共同推进当今的数字世界实现计算环境的现代化。`,
        awsTitle: 'AWS',
        awsText: `
        亚马逊网络服务（AWS）是一个安全的云服务平台，提供计算能力，数据库存储，内容交付和其他功能，以帮助企业不断发展。目前，数百万客户正在利用AWS云产品和解决方案来构建复杂的应用程序，同时提高灵活性，可扩展性和可靠性。`,
        dcTitle: 'Digital Ocean',
        dcText: `
        数字海洋是全球开发人员创建现代应用程序的首选云，拥有超过350万开发人员和全球数据中心网络，我们专注于开源和便捷，允许开发人员及其团队将更多的时间用于创新，而不是管理复杂的基础架构。`
      },
      developer: {
        title: '开发者',
        pnTitle: 'Portal Network',
        pnText: `NKN正在与Portal Network合作，为NKN网络开发NKN域名服务（NNS）。`,
        o3Title: 'O3 Labs',
        o3Text: `NKN正在与O3 实验室合作，O3钱包将支持NKN Token的钱包管理与转账。`,
        w3iTitle: 'Web3infra alliance',
        w3iText: `Web3Infra Alliance intend to unify the decentralized ecosystem by integrating different Web3 components to create an open and unified environment`
      },
      blockchain: {
        title: '区块链项目',
        IoTeXTitle: 'IoTeX',
        IoTeXText: `
        IoTeX是物联网（IoT）的自动可扩展和以隐私为中心的区块链平台。 IoTeX正在开发几项内部创新，以推动区块链3.0的前沿，包括用于异构计算的区块链架构，用于高可扩展性的Roll-DPoS共识机制以及轻量级的隐私保护技术。`,
        UUUTitle: 'UUU',
        UUUText: `
        NKN与U网合作，为U 网的内容发布和评估平台提供更快的网络传输，并为U 网生态系统内的所有DApp开发人员和企业提供网络工具和服务。`,
        dxcTitle: 'DXChain',
        dxcText: `
        NKN正在与O3 实验室合作，O3钱包将支持NKN Token的钱包管理与转账。`
      },
      equipment: {
        title: '网络设备供应商',
        nokiaTitle: '诺基亚',
        nokiaText:
          'NKN是诺基亚开放生态系统的一个组成部分，作为2018年诺基亚开放创新挑战赛的唯一一个区块链领域决赛入围者，被公认为是创新的代表。NKN还与诺基亚数字创新加速孵化器Datapace合作，在NKN的全球点对点网络上对Datapace的分布式数据市场和传感器生态系统提供网络支持。'
      },
      iQIYI: {
        title: "爱奇艺",
        text: 'NKN与爱奇艺携手推进在视频分发领域的技术创新研究。爱奇艺有限公司是一家创新的、领先市场的中国在线娱乐服务公司。'
      },
      chinaMobile: {
        title: 'China Mobile',
        text: 'NKN has signed a collaboration agreement with a division of China Mobile in Southern China: covering key areas such as cloud computing, network, and blockchain. The first real use case will be content delivery over China Mobile’s edge data center.'
      },
      netnic: {
        title: 'NETNIC',
        text: 'NKN signed a commercial contract with NETNIC for New Kind of Content Delivery Service, nCDN. By working together with NKN, NETNIC can continue to improve its content delivery services for its clientele of more than 100,000 enterprise customers.'
      }
    }
  },
  news: {
    title: '新闻',
    socialMedia: {
      title: '社交媒体更新',
      newsList: {
        advisor: {
          title:
            'Founder and CEO Stephen Wolfram Joins NKN As Technical Advisor',
          time: 'Dec 18, 2018',
          desc:
            'NKN announces Dr. Stephen Wolfram, founder and CEO of Wolfram Research, has joined the NKN project as technical advisor. Wolfram will provide technical guidance and entrepreneurial mentorship to the NKN project.'
        },
        nokia: {
          title: 'NKN Finalist for Nokia Open Innovation Challenge 2018',
          time: 'Dec 12, 2018',
          desc:
            'NKN was chosen as one of the 6 finalists out of over 300 applicants in the Nokia Open Innovation Challenge 2018 and was invited to present at the awards ceremony on December 6th in Murray Hill, NJ, all expenses paid by Nokia.'
        },
        redemption: {
          title: 'Early redemption of NKN test tokens',
          time: 'Dec 5, 2018',
          desc:
            'In order to recognize and reward our early adopters and miners, we would like to offer a special early redemption of the NKN test tokens mined up to date.'
        }
      }
    },
    video: {
      title: '视频更新'
    }
  },
  about: {
    titleText: `NKN由一批具有多年网络传输和区块链技术经验的企业家和工程师于2018年1月正式创立。核心成员曾就职于如谷歌、诺基亚、高通、百度，Onchain等公司。NKN团队致力于结合并创新区块链与网络技术，推动新一代互联网应用与业务的发展。
NKN团队在加利福尼亚州硅谷和中国北京两地均设有办公室。`,
    map: {
      tag1: '加利福尼亚州硅谷',
      tag2: '中国北京'
    },
    member: {
      title: '核心团队和顾问',
      yanbo: {
        name: '李彦博',
        position1: 'NKN 创始人 | 战略及系统架构',
        position2: '前Onchain联合创始人',
        intro: `自由软件和开源运动倡导者，Linux核心网络子系统代码贡献者。
        丰富的区块链底层架构设计及开发经验。
        曾在高通，诺基亚有超过10年P2P/Mesh网络协议研发经历。`
      },
      bruce: {
        firstname: 'Zheng',
        lastname: `“Bruce” Li`,
        position1: '联合创始人',
        position2: '战略与运营',
        intro: `曾在Google和Nokia领导多个网络
        技术创新项目，并成功推向市场。
        网络新领域开拓者，专注于企业
        战略和商务发展。
        `
      },
      yilun: {
        name: `张逸伦`,
        position1: '联合创始人',
        position2: '核心研究和开发',
        intro: `加州大学圣地亚哥分校物理学博士北京大学物理学本科。
        研究方向为计算神经科学和分布式信息处理系统。
        多年全栈工程师经验。`
      },
      allen: {
        name: `Allen Dixon`,
        position1: '商务拓展',
        position2: '法务合规',
        intro: `擅长将技术与市场紧密对接， 创造新的商业模式。
        在电信行业拥有20年以上的丰富经验，曾领导多个与Apple、Amazon和初创企业合作的项目。`
      },
      diffle: {
        name: 'Whitfield Diffie',
        honor1: '公钥密码学发明人（Diffie-Hellman）',
        honor2: '2015年图灵奖得主',
        honorlist: {
          row1: '皇家学会会员；',
          row2: '国家工程院院士；',
          row3: '瑞士联邦理工学院荣誉博士学位；',
          row4: '马可尼基金会成员；',
          row5: '伦敦大学皇家霍洛威学院博士（Honoris Causa）；',
          row6: '1981年获得IEEE Donald G. Fink奖论文奖；',
          row7: '1997年获得富兰克林研究所Louis E. Levy勋章；',
          row8: '荣获IEEE信息理论学会Golden Jubilee技术创新奖；',
          row9: '2010年荣获IEEE Richard W. Hamming奖章。'
        }
      },
      wolfram: {
        name: 'Stephen Wolfram',
        honor1: 'Wolfram Research 创始人兼CEO',
        honorlist: {
          row1: '1979年获得加州理工学院理论物理学博士；',
          row2: '1981年获得麦克阿瑟天才奖；',
          row3: '1983-1986年高级研究所长期成员；',
          row4: '复杂系统研究中心创始人；',
          row5: '伊利诺伊大学香槟分校数学、计算机科学、物理学兼职教授；',
          row6: '复杂系统杂志创办人；',
          row7: '美国科学促进协会会员；',
          row8: '《新科学》畅销书作者；',
          row9: '2012年SXSW互动数字社区巨大影响力活动奖获得者、演讲者；',
          row10: '美国数学学会首届院士；',
          row11: '数学博物馆奠基创始人。'
        }
      }
    },
    roadmap: {
      title: '产品路线图',
      testnetFlag: '测试网',
      mainnetFlag: '主网',
      firefox: {
        time: '2018年6月16日',
        title: 'v0.1“Firefox”版本发布',
        desc: 'NKN发布的第一个全节点实时测试网，验证核心子系统的可行性'
      },
      lemur: {
        time: '2018年8月',
        title: 'v0.3“Lemur”版本发布',
        desc: '增强可扩展性和转发效率的测试网，发布客户端SDK alpha版本'
      },
      koala: {
        time: '2018年10月',
        title: 'v0.5“Koala”版本发布',
        desc:
          '开放社区节点加入，支持极大规模节点部署的测试网，发布客户端SDK beta版本'
      },
      meerkat: {
        time: '2019年1月',
        title: 'v0.7“Meerkat”版本发布',
        desc: '具备全功能的测试网，增强抗攻击性，发布客户端SDK v1.0正式版本'
      },
      beluga: {
        time: '2019年3月',
        title: 'v0.9“Beluga”版本发布',
        desc: '基于测试网的实测基础，进一步开发和提升NKN的核心系统'
      },
      narwhal: {
        time: '2019年6月',
        title: 'v1.0“Narwhal”版本发布',
        desc: '正式启动主网和NKN生态系统'
      }
    },
    partnerTitle: '合作伙伴和联盟',
    exchangeTitle: '交易所',
    texture: {
      text1: 'Free the bits,',
      text2: 'rebuild the Internet we always wanted'
    }
  },
  nMobileDownload: {
    nMobile: 'nMobile',
    powered: '由NKN提供技术支持',
    description: 'nMobile是一款真正基于去中心化网络，实现了零服务器，端到端加密的通信工具。nMobile，为你的通信安全与隐私提供强力保障，让你放心地与世界交流。',
    userBenefits: '对用户而言有以下优点',
    extraSecureChat: '安全可靠的通信APP',
    security:{
      title: '注重安全和隐私',
      item1:{
        title: '数据储存',
        detail: '个人信息和通讯数据只在本地存储',
      },
      item2:{
        title: '无中心化服务器',
        detail: '消除云服务器的安全隐患',
      },
      item3:{
        title: '100%开放源代码',
        detail: '公开，透明，可信',
      },
      item4:{
        title: '私钥',
        detail: '私钥存储和认证过程不涉及服务器交互',
      },
      item5:{
        title: '端到端加密',
        detail: '任何中继节点都无法偷窥',
      },
    },
    secureChatCompared: {
      title: '产品对比',
      detail: '<p>nMobile比以往的通信APP更加安全</p> <br> <p>作为开源项目，nMobile<a target="_blank" class="link" href="https://github.com/nknorg/nMobile">代码完全公开</a>， 不给作恶和后门任何机会。</p>',
    },
    mobileCryptoWallet: {
      title: '手机加密钱包',
      subContent1: '随时随地管理NKN账户余额和付款（主网和ERC-20）',
      subContent2: '在主网和ERC-20之间兑换NKN（将来使用）'
    },
    securePrivateChat: {
      title: '安全和私人聊天',
      subContent1: '无需服务器，端到端直连的加密消息传递机制， 用户信息只存在于本地',
      subContent2: '开放协议， nMobile和D-Chat用户之间可以互通聊天， D-Chat插件可在',
      and: '和',
      browsers: '浏览器上使用。',
      Chrome: '谷歌',
      FireFox: '火狐'
    },
    secureRemoteAccess: {
      title: '安全的远程访问（即将推出）',
      subContent1: '使用安全消息传递，通过nShell远程管理IOT设备，视频监控或远程服务器等',
      subContent2: '大文件的安全共享直传'
    },
    learnMore: {
      title: '了解更多',
      item1: {
        title: 'nMobile: 值得信赖的通信APP'
      },
      item2: {
        title: 'nMobile简介 - 安全可靠的聊天软件'
      }
    },
    download: '下载',
    wxtips: '点击右上角<br>选择在浏览器中打开',
    ScanToDownload: '扫码下载',
    DownloadFor: '下载客户端',
    production: '稳定版',
    beta: '社区公测版'
  },
  nMobileProDownload: {
    nMobile: 'nMobile Pro',
    powered: '由NKN提供技术支持',
    description: 'nMobile Pro在nMobile的基础上，增加了nCDN和nConnect等一系列商用功能；除了通信安全与隐私提供强力保障外，还能让您享受NKN实际带来生活上的便利。',
    userBenefits: '对用户而言有以下优点',
    extraSecureChat: 'nMobile 商业版',
    security:{
      title: '注重安全和隐私',
      item1:{
        title: '数据储存',
        detail: '个人信息和通讯数据只在本地存储',
      },
      item2:{
        title: '无中心化服务器',
        detail: '消除云服务器的安全隐患',
      },
      item3:{
        title: '100%开放源代码',
        detail: '公开，透明，可信',
      },
      item4:{
        title: '私钥',
        detail: '私钥存储和认证过程不涉及服务器交互',
      },
      item5:{
        title: '端到端加密',
        detail: '任何中继节点都无法偷窥',
      },
    },
    secureChatCompared: {
      title: '产品对比',
      detail: '<p>nMobile比以往的通信APP更加安全</p> <br> <p>作为开源项目，nMobile<a target="_blank" class="link" href="https://github.com/nknorg/nMobile">代码完全公开</a>， 不给作恶和后门任何机会。</p>',
    },
    mobileCryptoWallet: {
      title: '手机加密钱包',
      subContent1: '随时随地管理NKN账户余额和付款（主网和ERC-20）',
      subContent2: '在主网和ERC-20之间兑换NKN（将来使用）'
    },
    securePrivateChat: {
      title: '安全和私人聊天',
      subContent1: '无需服务器，端到端直连的加密消息传递机制， 用户信息只存在于本地',
      subContent2: '开放协议， nMobile和D-Chat用户之间可以互通聊天， D-Chat插件可在',
      and: '和',
      browsers: '浏览器上使用。',
      Chrome: '谷歌',
      FireFox: '火狐'
    },
    secureRemoteAccess: {
      title: '安全的远程访问（即将推出）',
      subContent1: '使用安全消息传递，通过nShell远程管理IOT设备，视频监控或远程服务器等',
      subContent2: '大文件的安全共享直传'
    },
    learnMore: {
      title: '了解更多',
      item1: {
        title: 'nMobile: 值得信赖的通信APP'
      },
      item2: {
        title: 'nMobile简介 - 安全可靠的聊天软件'
      }
    },
    download: '下载',
    wxtips: '点击右上角<br>选择在浏览器中打开',
    ScanToDownload: '扫码下载',
    DownloadFor: '下载客户端',
    production: '稳定版',
    beta: '社区公测版'
  }
});



// WEBPACK FOOTER //
// ./src/i18n/zh.js